import PropTypes from "prop-types";
import { Calendar } from "lucide-react";

const HighlightedInfo = ({ icon: Icon = Calendar, title, items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div
      className="px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg"
      style={{ backgroundColor: "#F0FDF4" }}
    >
      <div className="flex items-center gap-1.5 sm:gap-2 mb-1.5 sm:mb-2">
        <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" style={{ color: "#01793B" }} />
        <span className="text-xs sm:text-sm font-semibold" style={{ color: "#01793B" }}>
          {title}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:gap-4 mt-2 sm:mt-3">
        {items.map(
          (item, index) =>
            item?.label && (
              <div key={index}>
                <div className="text-[10px] sm:text-xs mb-0.5 sm:mb-1" style={{ color: "#515164" }}>
                  {item.label}
                </div>
                <div className="text-xs sm:text-sm font-semibold leading-tight" style={{ color: "#3B3B3B" }}>
                  {item.value}
                </div>
              </div>
            ),
        )}
      </div>
    </div>
  );
};

HighlightedInfo.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};

export default HighlightedInfo;
